import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["getRowActions", "onRowActionClick", "columns"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import { defaultMemoize } from 'reselect';

// Constants
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// Components
import ActionCellRenderer from './actionCellRenderer';

// Styles
import styles from './withRowActions.module.scss';
var withRowActions = function withRowActions(WrappedComponent) {
  var WithRowActions = /*#__PURE__*/function (_Component) {
    _inherits(WithRowActions, _Component);
    var _super = _createSuper(WithRowActions);
    function WithRowActions(props) {
      var _this;
      _classCallCheck(this, WithRowActions);
      _this = _super.call(this, props);
      _defineProperty(_assertThisInitialized(_this), "getColumns", function (columns) {
        var _assertThisInitialize = _assertThisInitialized(_this),
          actionCell = _assertThisInitialize.actionCell;
        return [].concat(_toConsumableArray(columns), [actionCell]);
      });
      _defineProperty(_assertThisInitialized(_this), "getMemoizedColumns", defaultMemoize(_this.getColumns));
      _defineProperty(_assertThisInitialized(_this), "makeActionCellConfig", function () {
        var _this$props = _this.props,
          columnConfigurator = _this$props.columnConfigurator,
          getRowActions = _this$props.getRowActions;
        return _objectSpread(_objectSpread({}, columnConfigurator), {}, {
          id: 'action',
          Cell: _this.renderActionCell,
          width: 48,
          accessor: getRowActions,
          headerClassName: "configuratorHeader ".concat(styles.columnConfigurator)
        });
      });
      _defineProperty(_assertThisInitialized(_this), "renderActionCell", function (cellProps) {
        var _this$props2 = _this.props,
          onRowActionClick = _this$props2.onRowActionClick,
          actionCellRenderer = _this$props2.actionCellRenderer;
        var ActionCell = actionCellRenderer || ActionCellRenderer;
        return /*#__PURE__*/React.createElement(ActionCell, _extends({}, cellProps, {
          onRowActionClick: onRowActionClick
        }));
      });
      _this.actionCell = _this.makeActionCellConfig();
      return _this;
    }
    _createClass(WithRowActions, [{
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
          getRowActions = _this$props3.getRowActions,
          onRowActionClick = _this$props3.onRowActionClick,
          columns = _this$props3.columns,
          restProps = _objectWithoutProperties(_this$props3, _excluded);
        var memoizedColumns = this.getMemoizedColumns(columns);
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, restProps, {
          columns: memoizedColumns
        }));
      }
    }]);
    return WithRowActions;
  }(Component);
  WithRowActions.propTypes = {
    columns: PropTypes.array,
    columnConfigurator: PropTypes.object,
    getRowActions: PropTypes.func,
    onRowActionClick: PropTypes.func,
    actionCellRenderer: PropTypes.element
  };
  WithRowActions.defaultProps = {
    columns: EMPTY_ARRAY,
    columnConfigurator: EMPTY_OBJECT,
    getRowActions: _noop,
    onRowActionClick: _noop,
    actionCellRenderer: undefined
  };
  return WithRowActions;
};
export default withRowActions;